module.exports = __webpack_public_path__ + "img/niu19.f7483b77.jpg";